import api_client from '@/repositories';
import IResource from '@/types/IResource';
import IResourceGroup from '@/types/IResourceGroup';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

export default function useResourceDetailsPage() {
	const { id } = useParams<{ id: string }>();

	/**
	 * Fetch every data required to render the page
	 */
	const query = useQuery({
		queryKey: ['resources+groups', id],
		queryFn: async function queryResourceDetailsAndResources() {
			const [resource, resourceGroups] = await Promise.all([
				api_client.resources.details({ id }),
				api_client.resourceGroups.list(),
			]);

			return {
				resource,
				resourceGroups,
			};
		},
		cacheTime: 0,
	});

	return {
		status: query.status,
		props: {
			resource: query.data?.resource as IResource,
			resourceGroups: query.data?.resourceGroups?.resourceGroups || ([] as IResourceGroup[]),
		},
	};
}
